import React from "react";
import styled from "styled-components";
import { Oval } from "react-loader-spinner";

const OverlayWrapper = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
`;

const SpinnerOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
`;

const PitchLoadingOverlay = ({ loading, children }) => {
  const isLightTheme = localStorage.getItem("theme") === "light";

  return (
    <OverlayWrapper>
      {children}
      {loading && (
        <SpinnerOverlay>
          <Oval
            visible
            height="80"
            width="80"
            secondaryColor={isLightTheme ? "#4E5255" : "#CFDAE6"}
            color={isLightTheme ? "#2363F7" : "#4fa94d"}
            ariaLabel="oval-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />
        </SpinnerOverlay>
      )}
    </OverlayWrapper>
  );
};

export default PitchLoadingOverlay;
